<footer>
    <div class="container">
        <div class="row">
            <div class="col-md-6">Axing Zrt. / <a href="https://www.axing.hu/" target="_blank"><mat-icon>language</mat-icon> axing.hu</a> / <a href="mailto:kapcsolat@axing.hu"><mat-icon>email</mat-icon> kapcsolat&#64;axing.hu</a> / <mat-icon>phone</mat-icon> +36-1-248-0779</div>
            <div class="col-md-6 text-end">
                {{currentYear}} <span translate>ALL_RIGHTS_RESERVED</span>.

                <button mat-button [matMenuTriggerFor]="menu">{{locale}}</button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="setLocale('hu')" translate>HUNGARY</button>
                    <button mat-menu-item (click)="setLocale('en')" translate>ENGLISH</button>
                </mat-menu>
            </div>
        </div>
    </div>
</footer>
